import { BookingDetail } from "@app/core/booking/domain/model/booking-detail";
import { BookingStatus } from "@app/core/booking/domain/model/booking-status";
import { MatchStat } from "@app/core/match/domain/model/match";
import { DateMapper } from "@app/core/shared/data/network/date.mapper";

const bookingStatusMapper = {
  "payment-missing": BookingStatus.PAYMENT_MISSING,
  "other-payments-missing": BookingStatus.OTHER_PAYMENTS_MISSING,
  "reception-validation-missing": BookingStatus.RECEPTION_VALIDATION_MISSING,
  "match-ready-to-play": BookingStatus.MATCH_READY_TO_PLAY,
};

export class BookingDetailMapper {
  static deserialize(data: any): BookingDetail {
    return new BookingDetail(
      data.code,
      DateMapper.deserialize(data.date),
      data.duration_minutes,
      data.club,
      data.pista,
      data.location,
      bookingStatusMapper[
        data.match_request_stat as keyof typeof bookingStatusMapper
      ],
      data.integrated,
      data.players,
    );
  }
}
